export function useCopyBuildUrl() {
  const copyUrlToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      return true;
    } catch (err) {
      return false;
    }
  };

  return {
    copyUrlToClipboard,
  };
}
